/**
 * GraphQL Initialization
 *
 * Initializes the GraphQL client with environment variables.
 * Must be called before any GraphQL operations.
 */

import { initGraphQL } from '@business-assistant/shared';

let initialized = false;

export function initializeGraphQL(): void {
  // console.log('[GraphQL Init] initializeGraphQL called, initialized:', initialized);
  if (initialized) {
    // console.log('[GraphQL Init] Already initialized, skipping');
    return;
  }

  const url = import.meta.env.VITE_GRAPHQL_URL || 'https://database.teknology.eu/graphql';
  const token = import.meta.env.VITE_GRAPHQL_TOKEN || '';

  // console.log('[GraphQL Init] URL:', url);
  // console.log('[GraphQL Init] Token present:', !!token, 'length:', token.length);

  if (!token) {
    console.warn('GraphQL token not configured. Set VITE_GRAPHQL_TOKEN in .env');
    return;
  }

  initGraphQL(url, token);
  initialized = true;
  // console.log('[GraphQL Init] GraphQL client initialized successfully');
}
